<div class="w-full h-full flex flex-col gap-2 overflow-y-auto">
    <div class="w-full flex flex-col items-center justify-center gap-2">
        <h2 class="w-full oswald-font text-2xl">
            Parent Interview
        </h2>
        <!-- <p class="w-full">
            For use when interviewing staff members who witnessed or have direct knowledge about the threatening situation, and/or who have specific knowledge regarding the student or the threatening situation being reviewed. These questions provide a foundation for the interview, but may be modified or expanded as necessary depending on the circumstances.
        </p> -->
    </div>

    <div class="h-full w-full overflow-y-auto flex flex-col items-start justify-start gap-4">
        <ol class="flex items-center w-full">
            <li *ngFor="let step of stepsConfig" class="flex w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-100 after:border-4 after:inline-block">
                <button 
                    [attr.data-tooltip-target]="step.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === step.id,
                        'bg-orange-100': currentStep !== step.id && currentParentInterview?.[step.completionProperty] === 1,
                        'bg-gray-100': currentStep !== step.id && currentParentInterview?.[step.completionProperty] !== 1,
                        'cursor-not-allowed': step.nextStepDependency && currentParentInterview?.[step.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(step.id)"
                    [disabled]="step.nextStepDependency && currentParentInterview?.[step.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileUser" [ngClass]="{
                        'text-white': currentStep === step.id,
                        'text-nside-orange-400': currentStep !== step.id && currentParentInterview?.[step.completionProperty] === 1,
                        'text-gray-text': currentStep !== step.id && currentParentInterview?.[step.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="step.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[step.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
            <li class="flex items-center">
                <button 
                    [attr.data-tooltip-target]="finalStepConfig.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === finalStepConfig.id,
                        'bg-orange-100': currentStep !== finalStepConfig.id && currentParentInterview?.[finalStepConfig.completionProperty] === 1,
                        'bg-gray-100': currentStep !== finalStepConfig.id && currentParentInterview?.[finalStepConfig.completionProperty] !== 1,
                        'cursor-not-allowed': finalStepConfig.nextStepDependency && currentParentInterview?.[finalStepConfig.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(finalStepConfig.id)"
                    [disabled]="currentParentInterview?.[finalStepConfig.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileCheck" [ngClass]="{
                        'text-white': currentStep === finalStepConfig.id,
                        'text-nside-orange-400': currentStep !== finalStepConfig.id && currentParentInterview?.[finalStepConfig.completionProperty] === 1,
                        'text-gray-text': currentStep !== finalStepConfig.id && currentParentInterview?.[finalStepConfig.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="finalStepConfig.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[finalStepConfig.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
        </ol>
        <div class="w-full flex flex-col items-center justify-center overflow-y-auto gap-2">
            <parent-info 
                *ngIf="this.currentStep===1 && this.currentParentInterview"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection1)="handleUpdateParentInterview($event, 1)"
            ></parent-info>
            <parent-threat-knowledge 
                *ngIf="this.currentStep===2"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection2)="handleUpdateParentInterview($event, 2)"
            ></parent-threat-knowledge>
            <school-adjustment 
                *ngIf="this.currentStep===3"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection3)="handleUpdateParentInterview($event, 3)"
            ></school-adjustment>
            <family-relationship 
                *ngIf="this.currentStep===4"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection4)="handleUpdateParentInterview($event, 4)"
            ></family-relationship>
            <peer-relationship 
                *ngIf="this.currentStep===5"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection5)="handleUpdateParentInterview($event, 5)"
            ></peer-relationship>
            <problem-behavior 
                *ngIf="this.currentStep===6"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection6)="handleUpdateParentInterview($event, 6)"
            ></problem-behavior>
            <access-weapon 
                *ngIf="this.currentStep===7"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection7)="handleUpdateParentInterview($event, 7)"
            ></access-weapon>
            <exposure-violence 
                *ngIf="this.currentStep===8"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection8)="handleUpdateParentInterview($event, 8)"
            ></exposure-violence>
            <student-history 
                *ngIf="this.currentStep===9"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection9)="handleUpdateParentInterview($event, 9)"
            ></student-history>
            <characteristics 
                *ngIf="this.currentStep===10"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection10)="handleUpdateParentInterview($event, 10)"
            ></characteristics>
            <others 
                *ngIf="this.currentStep===11"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection11)="handleUpdateParentInterview($event, 11)"
            ></others>
            <parent-interview-official-signature 
                *ngIf="this.currentStep===12"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection12)="handleUpdateParentInterview($event, 12)"
            ></parent-interview-official-signature>
            <parent-interview-submission
                *ngIf="this.currentStep===13"
                class="w-full h-full overflow-y-auto"
                [parentInterviewData]="this.currentParentInterview" 
                (onSaveSection13)="handleUpdateParentInterview($event, 13)"
            ></parent-interview-submission>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>